import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Analitika.css';

const Analitika = () => {
  const [step, setStep] = useState(0);
  const [selectedRibarnice, setSelectedRibarnice] = useState([]);
  const ribarnice = ['Ribarnica 1', 'Ribarnica 2', 'Ribarnica 3'];

  const handleSelect = (ribarnica) => {
    setSelectedRibarnice((prev) =>
      prev.includes(ribarnica)
        ? prev.filter((r) => r !== ribarnica)
        : [...prev, ribarnica]
    );
  };

  const handleDownload = (type) => {
    if (selectedRibarnice.length === 0) return;
    console.log(`Download ${type} for:`, selectedRibarnice);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="analitika-container"
    >
      <AnimatePresence mode='wait'>
        {step === 0 ? (
          <motion.div
            key="step0"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            className="analitika-card text-center"
          >
            <h1 className="analitika-title">Izaberite tip izvještaja</h1>
            <div className="analitika-buttons">
              <button 
                className="analitika-button primary"
                onClick={() => setStep(1)}
              >
                <span className="icon">📅</span>
                Tjedni otpis
                <span className="description">Pregled dnevne prodaje</span>
              </button>
              <button 
                className="analitika-button secondary"
                onClick={() => setStep(2)}
              >
                <span className="icon">📊</span>
                Tjedna inventura
                <span className="description">Stanje zaliha i usklađenost</span>
              </button>
            </div>
          </motion.div>
        ) : (
          <motion.div
            key="step1"
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -100, opacity: 0 }}
            className="analitika-card"
          >
            <button 
              className="back-button"
              onClick={() => {
                setStep(0);
                setSelectedRibarnice([]);
              }}
            >
              &larr; Natrag
            </button>

            <h2 className="analitika-subtitle">
              Odaberite ribarnice za {step === 1 ? 'tjedni otpis' : 'tjednu inventuru'}
            </h2>
            
            <div className="analitika-checkboxes">
              {ribarnice.map((ribarnica) => (
                <label key={ribarnica} className="analitika-checkbox-item">
                  <input
                    type="checkbox"
                    checked={selectedRibarnice.includes(ribarnica)}
                    onChange={() => handleSelect(ribarnica)}
                  />
                  <span className="custom-checkbox"></span>
                  <span className="label-text">{ribarnica}</span>
                </label>
              ))}
            </div>

            <button
              className={`analitika-button download-btn ${
                selectedRibarnice.length === 0 ? 'disabled' : ''
              }`}
              onClick={() => handleDownload(step === 1 ? 'otpis' : 'inventura')}
              disabled={selectedRibarnice.length === 0}
            >
              ⬇️ Preuzmi {step === 1 ? 'tjedni otpis' : 'tjednu inventuru'}
              {selectedRibarnice.length > 0 && (
                <span className="counter">({selectedRibarnice.length})</span>
              )}
            </button>

            {selectedRibarnice.length === 0 && (
              <p className="error-message">Molimo odaberite barem jednu ribarnicu</p>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default Analitika;